import {  memo  } from 'react';
import List from '@mui/material/List';
import MapListItemFlower from './MapListItemFrower.js';
import {Box} from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import ListItem from '@mui/material/ListItem';
import {useSharedLang} from '../../hooks/useSharedLang.js';
import {LANGS } from "../../components/constants.js";


const MapListFlower = memo((props) => {
    const {flowers , selectFlower} = props;
    const { sharedLang } = useSharedLang();

    const data = () =>{
        return [
            {
              title: sharedLang === LANGS.ENGLISH
                ? 'Admire the flowers in full bloom at Chidorigafuchi, Tokyo’s leading cherry-blossom viewing spot, and other places around town.'
                : '都内屈指の花見スポット・千鳥ヶ淵や、ハナショウブ、ツツジなど咲き誇る花々を愛でよう',
              data: flowers.filter(
                el => el.seasons.season === 'spring' && el.name !== '',
              ),
              img: sharedLang === LANGS.ENGLISH ? 'spring@3x.png':'title-spring@3x.png',
            },
            {
              title: sharedLang === LANGS.ENGLISH
                ? 'Colorful weeping willow trees and hydrangea herald the beginnings of summer.'
                : '緑鮮やかなシダレヤナギや美しい色彩のアジサイが夏の到来を告げています',
              data: flowers.filter(el => el.seasons.season === 'summer'),
              img: sharedLang === LANGS.ENGLISH ? 'summer@3x.png':'title-summer@3x.png',
            },
            {
              title: sharedLang === LANGS.ENGLISH
                ? 'The perfect season for a stroll through the Imperial Palace. Enjoy colorful autumn foliage in Kitanomaru Park as you escape the hustle and bustle of the capital city.'
                : '都会の喧騒を忘れて、深紅に染まる北の丸公園で紅葉を堪能。絶好の皇居散策シーズン到来',
              data: flowers.filter(el => el.seasons.season === 'autumn'),
              img: sharedLang === LANGS.ENGLISH ? 'autumn@3x.png':'title-autumn@3x.png',
            },
            {
              title: sharedLang === LANGS.ENGLISH
                ? 'The best season for wild birds See narcissus and plum blossoms on the famous Bairinzaka slope.'
                : '野鳥ウォッチングに最適な時季。土手に咲くニホンズイセンや梅林坂の梅など冬花を楽しんで',
              data: flowers.filter(el => el.seasons.season === 'winter'),
              img: sharedLang === LANGS.ENGLISH ? 'winter@3x.png':'title-winter@3x.png',
            },
            {
              title: sharedLang === LANGS.ENGLISH ? 'All Seasons' : '通年',
              data: flowers.filter(el => el.seasons.season === 'all'),
              img: '',
            },
        ];
    }

    return (
        <div className="leaflet-container">
            <List className="map-list">
            {
                data().map((season, sIndex) => {
                    return <Box key={sIndex}>
                        {
                        season.data.length > 0?
                        <ListItem alignItems="flex-start">
                            <Card className={"flowerListItem section"}>
                            <Box sx={{display:'flex'}}>
                                {
                                season.img !== ''?
                                <>
                                <CardMedia
                                    component="img"
                                    sx={{ width: '3rem' }}
                                    image={"/assets/images/others/" + season.img}/>
                                <Box>{season.title}</Box>
                                </>
                                :<Box sx={{textAlign:'center',width:'100%',marginRight:'10px'}}>{season.title}</Box>
                                }
                            </Box>
                            </Card>
                        </ListItem>:<></>
                        }
                        <MapListItemFlower flowers={season.data} selectFlower={selectFlower} />
                    </Box>
                })
            }
            </List>
        </div>
    )
});
export default MapListFlower